import $ from 'jquery';

function init({ selector = '.js-c-hero-scroll' } = {}) {
    $(selector).on('click', function () {
        $('html, body').animate({ scrollTop: $(window).height() }, 600);
        return false;
    });
}

export default {
    init
};
